import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import {
  BillingDetailsModalLayoutJSON,
  BillingEditDetailsModalLayoutJSON,
} from "../Json/OrderDetailsLayoutJSON";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import {
  BillingDetailsModalFieldsJSON,
  BillingEditDetailsModalFieldsJSON,
} from "../Json/OrderDetailsFieldsJSON";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  openPolicyModal,
  resetFormState,
  setSelectValidError,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import useProductColumn from "../Hook/useProductColumn";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import { getFilteredDataWithTabs } from "../../../../Utils/CommonService";
import {
  getProductAttributes,
  getProductListing,
  readData,
  readPolicy,
} from "../OrderService";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";
import ProductModal from "../Modal/ProductModal";
import { InfoIcon } from "../../../../assets/images/svg/svg";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import PolicyModal from "../Modal/PolicyModal";
import ProductAttributesModal from "../Modal/ProductAttributesModal";
import ProductAttributesModalEdit from "../Modal/ProductAttributeModalEdit";
import {
  setProductVariantEdit,
  setSelectedPolicydata,
} from "../../../../slices/orders/orderSlice";
import ProductAttributeModalEdit from "../Modal/ProductAttributeModalEdit";

function Product({ onNext, onPrevious }) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showAttributeModal, setShowAttributeModal] = useState(false);
  const [selectedProductEntityId, setSelectedProductEntityId] = useState(null);
  const policyModal = useSelector((state) => state.common.policyModalShow);
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );
  // Editing attributes after payment is controlled by the EDIT_ATTRIBUTE module access
  const canEditPaidAttributes = checkButtonAccess
    ? checkButtonAccess("EDIT_ATTRIBUTE", "ORD_ORDS")
    : false;
  const isPaid =
    detailsData?.status === "PAYMENT_SUCCESS" ||
    detailsData?.status === "COMPLETED" ||
    Boolean(detailsData?.Policy_detail?.length);
  const loading = useSelector((state) => state.common.loading);
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );
  const policyData = useSelector(
    (state) => state.order.selectedOrders.policyData
  );

  const selectedPolicy = useSelector(
    (state) => state.order.selectedOrders.selectedPolicyData
  );

  const { id } = useParams();

  useEffect(() => {
    readPolicy(id, "ODR");
  }, []);

  const handleProductModal = (data) => {
    setSelectedProductEntityId(data);
    setShowModal(true);
  };

  const handleProductModalClose = () => {
    setShowModal(false);
  };

  // const handlePolicyModal = async (selectedPolicyRow) => {
  //   const matchedPolicy = policyData.find(
  //     (policy) => policy.sub_product_id === selectedPolicyRow?.entityid
  //   );
  //   if (matchedPolicy) {
  //     dispatch(setSelectedPolicydata(selectedPolicyRow?.entityid));
  //     dispatch(updateRendererFormState(matchedPolicy));
  //     dispatch(openPolicyModal(true));
  //   } else {
  //     console.warn("No matching policy found for", selectedPolicyRow?.entityid);
  //   }
  // };

  const [selectedPolicyRow, setSelectedPolicyRow] = useState(null);
  useEffect(() => {
    if (selectedPolicyRow && policyData?.length) {
      const matchedPolicy = policyData.find(
        (policy) =>
          policy.sub_product_id === selectedPolicyRow.entityid &&
          (policy.premium > 0 ||
            policy.policy_holder_name === detailsData?.customer_name ||
            policy.policy_holder_name === detailsData?.billing_name)
      ) || policyData.find(
        (policy) => policy.sub_product_id === selectedPolicyRow.entityid
      );
      if (matchedPolicy) {
        dispatch(setSelectedPolicydata(matchedPolicy));
        dispatch(updateRendererFormState(matchedPolicy));
        dispatch(openPolicyModal(true));
      } else {

        dispatch(setSelectedPolicydata(null));
        dispatch(openPolicyModal(true));
      }
      setSelectedPolicyRow(null);
    }
  }, [policyData, selectedPolicyRow]);

  const handlePolicyModal = async (row) => {
    setSelectedPolicyRow(row);
    await readPolicy(id, "ODR");
  };

  const handleClose = () => {
    setShowAttributeModal(false);
    setSelectedProductEntityId(null);
  };

  const handleVariantModal = (entityId) => {
    setSelectedProductEntityId(entityId);
    setShowAttributeModal(true); // Show the modal
  };

  const handleAttributesButtonClick = (entityId) => {
    handleVariantModal(entityId);
  };

  useEffect(() => {
    if (detailsData.product_id) {
      getProductAttributes(detailsData.product_id);
    }
  }, [detailsData.product_id]);

  const productData = useSelector(
    (state) => state.order.selectedOrders.selectedProductData
  );

  const order_id = useSelector(
    (state) => state.order.selectedOrders.detailsData.entityid
  );

  const params = useParams();
  const editMode = !!params.id;

  const productColumn = [
    {
      header: "Product Id",
      accessorKey: "code",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),

      size: 100,
    },

    {
      header: "Name",
      accessorKey: "name",
      // cell: (props) => {
      //   {props?.getValue() ? props?.getValue() : "-"}
      // },
      size: 200,
    },
    {
      header: "PSP",
      accessorKey: "psp_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "OEM",
      accessorKey: "oem_name",
      cell: (props) => (props?.getValue() ? props.getValue() : "-"),
      size: 200,
    },
    {
      header: "Product Category",
      accessorKey: "product_category",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Amount",
      accessorKey: "premium_amount",
      cell: (props) => (props?.getValue() ? "₹ " + props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "",
    //   accessorKey: "status",
    //   cell: (props) => (
    //     <div onClick={() => handleProductModal(props.row.original.entityid)}>
    //       <InfoIcon />
    //     </div>
    //   ),
    //   size: 50,
    // },
    // {
    //   header: "",
    //   accessorKey: "status",
    //   cell: (props) =>
    //     props.row.original.product_category === "Insurance" ? (
    //       <Button onClick={() => handlePolicyModal(props.row.original.product_category)}>
    //         Policy
    //       </Button>
    //     ) : null,
    // }
    {
      header: "",
      accessorKey: "action",
      cell: (props) => (
        <div className="d-flex gap-4 align-items-center">
          <div onClick={() => handleProductModal(props.row.original.entityid)}>
            <InfoIcon />
          </div>
          {props.row.original.product_category === "Insurance" &&
            detailsData.Policy_detail &&
            detailsData.Policy_detail.length > 0 && (
              <Button
                onClick={() => {
                  handlePolicyModal(props.row.original);
                  // readPolicy(props.row.original.entityid, "ODR");
                  // dispatch(updateRendererFormState(props.row.original));
                }}
              >
                Policy
              </Button>
            )}
        </div>
      ),
    },
  ];

  const fieldsJSON = editMode
    ? BillingEditDetailsModalFieldsJSON
    : BillingDetailsModalFieldsJSON;
  const layoutJSON = editMode
    ? BillingEditDetailsModalLayoutJSON
    : BillingDetailsModalLayoutJSON;

  useEffect(() => {
    getProductListing(order_id);
  }, [order_id]);

  // useEffect(() => {
  //   if (productVariantModalState.qualification) {
  //     const productId = detailsData?.product_id;
  //     const body = {
  //       qualification: productVariantModalState.qualification,
  //     };
  //     getDoctorCategory(productId, body);
  //   }
  // }, [productVariantModalState.qualification, detailsData?.product_id]);

  const handleNextClick = (e) => {
    e.preventDefault();
    onNext();
    // if (formState.cover_amount) {
    //   dispatch(setSelectValidError(false));
    //   onNext();
    // } else {
    //   dispatch(setSelectValidError(true));
    // }
  };

  const handlePreviousClick = (e) => {
    e.preventDefault();
    onPrevious();
  };

  return (
    <div>
      {/* <CommonHeader
        buttonTitle={"New"}
        formLink="/order/orders/create"
        dash={true}
      /> */}
      {(canEditPaidAttributes || !isPaid) &&
        detailsData.status !== "CANCELLED" && (
          <div className="d-flex justify-content-end mb-3">
            <Button
              className="flex-end"
              onClick={() => handleAttributesButtonClick(selectedProductEntityId)}
            >
              Attributes
            </Button>
          </div>
        )}
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <TableWrapper
            columns={productColumn}
            data={productData}
            hidePagination={true}
            hideTabsButtons={true}
          />
        </div>
      )}
      {policyModal && (
        <PolicyModal
        // show={policyModal}
        // onHide={handleProductModalClose}
        />
      )}
      {showModal && (
        <ProductModal
          selectedProductEntityId={selectedProductEntityId}
          show={showModal}
          onHide={handleProductModalClose}
        />
      )}
      {/* <ProductAttributesModalEdit
        show={showAttributeModal}
        onHide={handleClose}
        selectedProductEntityId={selectedProductEntityId}
      /> */}
      {/* <ProductAttributesModal
        show={showAttributeModal}
        onHide={handleClose}
        selectedProductEntityId={selectedProductEntityId}
        mode="edit"
      /> */}
      <ProductAttributeModalEdit
        show={showAttributeModal}
        onHide={handleClose}
        selectedProductEntityId={selectedProductEntityId}
        mode="edit"
      />
    </div>
  );
}

export default Product;
